.appSwitch {
  width: 1.5rem;
  > input {
    display: none;
  }

  > input:checked + svg {
    transform: scaleX(-1);
  }

  svg {
    width: 100%;

    path {
      fill: currentColor;
    }
  }
}

.label {
  user-select: none;
  display: inline-flex;
  gap: 0.5rem;

  &:has(input:checked) > :first-child,
  &:has(input:not(:checked)) > :last-child {
    opacity: 0.5;
  }
}
